/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { workspacesFetchById } from "../../funcs/workspacesFetchById.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .GetApiLeadScraperMicroserviceApiV1WorkspaceIdRequest$inboundSchema,
};

export const tool$workspacesFetchById: ToolDefinition<typeof args> = {
  name: "workspaces_fetch-by-id",
  description: `Get workspace details

Retrieves details of a specific workspace`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await workspacesFetchById(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
